module.exports = __webpack_public_path__ + "img/cert6-small.19597103.jpg";